export default "__VITE_ASSET__BXYbVcse__"